export default "__VITE_ASSET__DxZQbVSy__"